module.exports = __webpack_public_path__ + "img/El-Terrible.d94a8b75.jpg";